// @mui material components
import Card from "@mui/material/Card";
import Box from "@mui/material/Box"; // MUI Box 사용

// Data
import lightsData from "./data/lightsData";

// Products Contents
import LineUpContents from "./LineUpContents";
import LightsEco from "./lights/LightsEco";
import Lights from "./lights/Lights";

function Products() {
  // energy가 true인 데이터 필터링
  const { energyCategories, nonEnergyCategories } = lightsData.categories.reduce(
    (acc, category) => {
      const energyItems = category.items.filter((item) => item.energy === true);
      const nonEnergyItems = category.items.filter((item) => item.energy !== true);

      if (energyItems.length > 0) {
        acc.energyCategories.push({
          ...category,
          items: energyItems,
        });
      }

      if (nonEnergyItems.length > 0) {
        acc.nonEnergyCategories.push({
          ...category,
          items: nonEnergyItems,
        });
      }

      return acc;
    },
    { energyCategories: [], nonEnergyCategories: [] } // 초기값 설정
  );

  return (
    <>
      <LineUpContents />
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
          zIndex: 2,
        }}
      >
        {/* 고효율 및 일반제품 */}
        <Box id="energy-save-zone" sx={{ paddingTop: "70px", marginTop: "-70px" }}>
          {/* 에너지 절약 데이터 전달 */}
          <LightsEco data={energyCategories} />
        </Box>
        <Box id="line-up" sx={{ paddingTop: "70px", marginTop: "-70px" }}>
          {/* 원본 데이터를 전달 */}
          <Lights data={nonEnergyCategories} />
        </Box>
      </Card>
    </>
  );
}

export default Products;
